import React from 'react'

const BookingPackage = ({packages,errors,t,watch,setValue}) => {
  return (
    <>
      {packages && packages.length > 0 && (
        <div className="col-12">
          <label className="form-label fw-bold">{t("selectPackage")}</label>

          <div className="row g-3">
            {packages.map((pkg) => (
              <div key={pkg.packageId} className="col-12 col-md-6 col-lg-4">
                <label className={`w-100 cursor-pointer }`}>
                  <input
                    type="radio"
                    name="package"
                    value={pkg.packageId}
                    checked={watch("packageId") === pkg.packageId}
                    className="btn-check"
                    autoComplete="off"
                   onChange={() =>
                    setValue("packageId", pkg.packageId, {
                      shouldValidate: true,
                    })
                  }
                  />

                  <div
                    className={`card h-100 shadow-sm border-2 ${pkg.packageId === watch("packageId") ? "package-selected" : ""}`}
                  >
                    <div className="card-body flex-center flex-column">
                      <span className="text-primary">
                        {pkg.price} {t("riyal")}
                      </span>
                      <span className="text-muted">
                        {pkg.unit} | {pkg.unitNumber}
                      </span>
                    </div>
                  </div>
                </label>
              </div>
            ))}
            <div className="col-12">
              {errors.packageId && (
                <p className="text-danger">{errors.packageId.message}</p>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default BookingPackage